// Generate a unique hash.
export function unique(prefix = ''): string {
  const hash = Math.random().toString(16).split('.')[1].toUpperCase();

  return `${prefix}${hash}`;
}
